import { LoadingIcon } from 'morpheus-ui';
import React, { ComponentProps, HTMLAttributeAnchorTarget } from 'react';
import { Link } from 'react-router-dom';
import { VariantProps } from 'tailwind-variants';
import { Icon } from '../Icon';
import {
  button,
  buttonIcon,
  buttonMaterialIcon,
  loadingIcon,
} from './variants';

export type ButtonProps = ComponentProps<'button'> &
  VariantProps<typeof button> & {
    LeftIcon?: React.ComponentType<ComponentProps<'svg'>> | string;
    iconType?: 'svg' | 'material';
    iconSize?: 'mini' | 'small' | 'medium' | 'regular' | 'large';
    classNameIcon?: string;
    iconVariant?: 'rounded' | 'fill';
    asLink?: boolean;
    to?: string;
    target?: HTMLAttributeAnchorTarget;
  };

function Button({
  size = 'regular',
  variant = 'contained',
  orientation = 'horizontal',
  children,
  className,
  classNameIcon,
  iconVariant,
  loading,
  negative,
  disabled,
  LeftIcon,
  iconType = 'material',
  iconSize = 'regular',
  onlyIcon,
  full,
  asLink = false,
  to,
  target = '_self',
  ...props
}: ButtonProps) {
  const isEmpty = !children;

  const buttonElement = (
    <button
      {...props}
      disabled={disabled || loading}
      className={button({
        variant,
        size,
        orientation,
        negative,
        disabled,
        className,
        full,
        onlyIcon: onlyIcon ?? isEmpty,
      })}
    >
      {LeftIcon && !loading && (
        <Icon
          Icon={LeftIcon}
          variant={iconVariant}
          type={iconType}
          className={
            iconType === 'svg'
              ? buttonIcon({ iconSize, variant, className: classNameIcon })
              : buttonMaterialIcon({
                  variant,
                  iconSize,
                  className: classNameIcon,
                })
          }
        />
      )}
      {loading ? (
        <LoadingIcon className={loadingIcon({ size, variant })} />
      ) : null}
      {!onlyIcon && children}
    </button>
  );

  if (asLink) {
    return (
      <Link to={to ?? ''} target={target} className={full ? 'w-full' : ''}>
        {buttonElement}
      </Link>
    );
  }

  return buttonElement;
}

export { Button };
